import React from 'react'
import { localize } from 'services/base';

const Banner=()=>{
	const t = (key) => localize(key);
      return(
            <div className='p-1 pb-4' >
                <img style={{width:'100%'}} src={t('img_banner')} className="img-fluid" alt="banner" />
            </div>
      )
}

export default Banner